var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPro2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C15.5229 0 20 4.47711 20 10C20 15.5229 15.5229 20 10 20C4.47711 20 0 15.523 0 10C0 4.47699 4.47723 0 10 0ZM3.84766 13.5225C3.84766 13.527 3.84816 13.5311 3.84824 13.5354L8.05094 10.2611L3.84766 6.53703V13.5225ZM11.9492 10.2611L16.1518 13.5354C16.1518 13.5311 16.1525 13.527 16.1525 13.5225V6.53703L11.9492 10.2611ZM8.7202 10.854L4.67387 14.0063H15.3264L11.28 10.854L10.2914 11.7298C10.2111 11.801 10.1074 11.8403 10 11.8403C9.89266 11.8403 9.78901 11.801 9.70863 11.7298L8.72008 10.854H8.7202ZM10 10.8137L15.4404 5.99367H4.55965L10 10.8137Z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPro2);
export default __webpack_public_path__ + "static/media/pro-2.d94f5ff913a05d2039c4bca5459f5274.svg";
export { ForwardRef as ReactComponent };